import { PORTAL_BRAND } from '../../data/brand';

// deviation: STARPOINT_ICON_URI / STARPOINT_LOGO_URI are defined in legacy/App.tsx;
// copied verbatim as module-local consts (public asset paths, not logic) so this
// component is self-contained without touching the monolith.
const STARPOINT_ICON_URI = '/starpoint-icon.png';
const STARPOINT_ICON_WHITE_URI = '/starpoint-icon-white.png';
const STARPOINT_LOGO_URI = '/starpoint-logo.png';
const STARPOINT_LOGO_WHITE_URI = '/starpoint-logo-white.png';

export interface Padel24LogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'full' | 'icon';
  /** `light` draws the white wordmark, for the brand-purple surfaces. */
  tone?: 'dark' | 'light';
}

/**
 * Portal logo (Starpoint) — renders the brand's icon or full horizontal logo as an
 * <img>. Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged.
 */
export function Padel24Logo({ size = 'md', variant = 'full', tone = 'dark' }: Padel24LogoProps) {
  // Portal-logo (Starpoint). Bruker brukerens faktiske logo som innebygd bilde.
  // size: xs | sm | md | lg | xl. variant: 'full' (ikon + tekst) | 'icon' (kun ikon)
  const heights: Record<string, number> = { xs: 20, sm: 28, md: 32, lg: 40, xl: 48 };
  const h = heights[size] || 32;
  const isIcon = variant === 'icon';
  const light = tone === 'light';
  const src = isIcon
    ? light
      ? STARPOINT_ICON_WHITE_URI
      : STARPOINT_ICON_URI
    : light
      ? STARPOINT_LOGO_WHITE_URI
      : STARPOINT_LOGO_URI;
  return (
    <img
      src={src}
      alt={PORTAL_BRAND.name}
      style={{ height: h, width: 'auto', display: 'block' }}
      className="select-none flex-shrink-0"
      draggable={false}
    />
  );
}
